export default __webpack_public_path__ + "static/media/undraw_Experts_re_i40h.185f06f4.svg";